import { useMemo } from 'react';
import { endOfDay, isSameMonth, startOfDay } from 'date-fns-new';
import { getDaysOfMonth, isToday } from "../../utils/date";
import { isDisableDate } from "../../utils/isDisabledDate";
import { isInMinMaxDate } from "../../utils/isInMinMax";
import { getNewRangeValidValue } from "../../utils/getValidValue";
import { getDateView, isNotRangeParams, isRangeParams } from "./utils";
export var useDaysList = function useDaysList(params) {
  var currentVisibleDate = params.currentVisibleDate,
    value = params.value,
    maxDate = params.maxDate,
    minDate = params.minDate,
    disableDates = params.disableDates,
    locale = params.locale;
  var valueArr = Array.isArray(value) ? value : [value || null, null];
  var handleClick = function handleClick(date) {
    return function (e) {
      if (!params.onChange) {
        return;
      }
      if (isNotRangeParams(params)) {
        params.onChange(date, e);
      }
      if (isRangeParams(params)) {
        params.onChange(getNewRangeValidValue(date, valueArr, minDate, maxDate, disableDates), e);
      }
    };
  };
  return useMemo(function () {
    return getDaysOfMonth(currentVisibleDate, locale).map(function (date) {
      var disabled = !isInMinMaxDate(date, minDate, maxDate, startOfDay, endOfDay) || isDisableDate({
        date: date,
        disableDates: disableDates
      });
      return {
        label: date.getDate(),
        date: date,
        accent: !isSameMonth(date, currentVisibleDate),
        disabled: disabled,
        view: getDateView(date, valueArr),
        onClick: handleClick(date),
        isCurrentDate: isToday(date)
      };
    });
  }, [valueArr, currentVisibleDate, maxDate, minDate, disableDates]);
};